import { Button, Card, Grid, Icon, Input } from "@scuf/common";
import "../OrderSummery/OrderSummery.css";
import "./ApplyCoupon.css";
import { useEffect, useState } from "react";
import ApplyCouponActions from "../redux/actions/apply-coupon-actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { InLineLoader } from "../Loader/Loader";
import DiscountIcon from "./images/iconamoon_discount-fill.svg";
import ApplyCouponApiActions from "../redux/actions/apply-coupon-api-actions";

const ApplyCoupon = (props) => {
  const [inputData, setInputData] = useState<string>("");
  const [applyCouponData, setApplyCouponData] = useState<string>("");
  const [show, setShow] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); // State for loading indicator

  const { discountAmount } = props;
  let isCouponApply = props.couponData?.isCoupon;
  let checkCouponData = props?.data?.data?.promoCode;

  const checkInputCoupon = (e: string) => {
    setInputData(e);
  };

  // Validate if coupon is alphanumeric and length is less than or equal to 10
  const isValidCoupon = (coupon) => {
    return /^[a-zA-Z0-9]{1,10}$/.test(coupon);
  };

  useEffect(() => {
    setErrorMessage("");
  }, [inputData]);

  useEffect(() => {
    // if (!props.isFetching && props.isSuccess) {
      if (checkCouponData === inputData) {
        setShow(true);
        setApplyCouponData(inputData);
        props.hasApplied(true);
        setErrorMessage("");
      }
      // Turn off loader after API call completes
      setIsLoading(false);
    // }
  }, [checkCouponData]);

  const checkCoupon = async (activeCupon?: string) => {
    // Call API to check coupon validity
      const currentCoupon = activeCupon || inputData;

      if (!isValidCoupon(currentCoupon)) {
        setErrorMessage("Invalid coupon");
        setIsLoading(false);
        return;
      }

      // Set loading state before API call and if condition is added to not load loader again if already coupon code is there
      if (!isCouponApply) {
        setIsLoading(true);
      }


      // Check if the coupon matches
      if (!props.isFetching && props.isSuccess) {

      if (checkCouponData === currentCoupon) {
        setShow(true);
        setApplyCouponData(currentCoupon);
        props.hasApplied(true);
        setErrorMessage("");
        setIsLoading(false);
        // localStorage.setItem("APPLIED_COUPON", currentCoupon);
      } else {
        setErrorMessage("Invalid coupon");
        setIsLoading(false);
      }
    }

    await props.getCouponData(currentCoupon);
      
  };

  // useEffect(() => {
  //   const c = localStorage.getItem("APPLIED_COUPON");
  //   debugger;
  //   if (c) {
  //     setInputData(c);

  //     checkCoupon(c);
  //   }
  // }, []);

  const removeCoupon = () => {
    setShow(false);
    setInputData("");
    props.hasApplied(false);
    setErrorMessage("");
  };

  const couponAppliedOrNot = (value: string) => {
    return (
      <Card.Content className="coupon-card-content">
        <Input
          placeholder="Promo Code"
          disabled={false}
          type="string"
          className="datatable-text-input"
          fluid={true}
          value={errorMessage ? "" : value}
          onChange={(e) => checkInputCoupon(e)}
        />
        <Button
          content="Apply"
          textTransform={true}
          className="apply-discount"
          onClick={() => checkCoupon()}
        />
      </Card.Content>
    );
  };

  return (
    <div>
      <Card>
        <Card.Header title="Apply Discount" className="order-summary-title" />
        {!isCouponApply
          ? couponAppliedOrNot(inputData)
          : couponAppliedOrNot(checkCouponData)}
        {errorMessage && (
          <Card.Content className="invalid-coupon">
            Invalid coupon code
          </Card.Content>
        )}
        {isLoading && (
          <div className="pb10">
            <InLineLoader
              loading={true}
              text="Fetching Coupon Data"
              overlayColor="transparent"
            />
          </div>
        )}
        {isCouponApply && (
          <Card.Content className="main-grid-content">
            <Grid.Row>
              <Grid.Column width={9} sWidth={12} className="grid-column">
                <div className="grid-column-div">
                  <Icon
                    root="common"
                    name="check"
                    size="small"
                    color="white"
                    className="check-icon"
                  />

                  <label className="pl10">
                    <p className="main-code mb0">
                      {isCouponApply ? checkCouponData : applyCouponData}

                      <img
                        src={DiscountIcon}
                        className="discount-icon"
                        alt="Discount Icon"
                      />
                    </p>
                    <p className="coupon-code">
                      Get USD {discountAmount.data} Instant Discount
                    </p>
                  </label>
                </div>
              </Grid.Column>
              <Grid.Column width={3} sWidth={12}>
                <p className="remove-btn" onClick={removeCoupon}>
                  Remove
                </p>
              </Grid.Column>
            </Grid.Row>
          </Card.Content>
        )}
      </Card>
    </div>
  );
};

const mapDispatchToProps = {
  hasApplied: ApplyCouponActions.hasApplied,
  getCouponData: ApplyCouponApiActions.getCouponData,
};

function mapStateToProps(state) {
  const data1 = state.couponApiSummary?.couponApiSummary;
  const data = data1?.data;
  const isSuccess = data1?.isSuccess;
  const isFetching = data1?.isFetching;

  const couponData1 = state.couponSummary?.couponSummary;
  const couponData = couponData1?.couponData;

  const discountAmount1 = state.cartListData?.cartListData;
  const discountAmount = discountAmount1?.discountAmount;

  if (!isFetching && isSuccess) {
    return {
      data,
      isSuccess,
      isFetching,
      couponData,
      discountAmount,
    };
  }
  return {
    data: void 0,
    isSuccess,
    isFetching,
    couponData,
    discountAmount,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ApplyCoupon));
